import clsx from 'clsx'
import { motion } from 'motion/react'
import { useEffect } from 'react'

import { withPublicImageUrl } from '@lib/utils/cdn'

import {
  Stage,
  PLUS_BUTTON_CLICK_DURATION,
  CONTEXT_MENU_VISIBLE_ANIMATION_DURATION,
  CONTEXT_MENU_STAY_VISIBLE_DURATION,
  SOURCE_CLICK_DURATION,
} from './constants'

import style from './context-menu.module.scss'

export const ContextMenu = ({
  stage,
  setStage,
}: {
  stage: Stage
  setStage: (stage: Stage) => void
}) => {
  const contextMenuVisibleDelay = PLUS_BUTTON_CLICK_DURATION

  const sourceClickDelay =
    PLUS_BUTTON_CLICK_DURATION +
    CONTEXT_MENU_VISIBLE_ANIMATION_DURATION +
    CONTEXT_MENU_STAY_VISIBLE_DURATION

  useEffect(() => {
    let timeoutId: NodeJS.Timeout
    const goToSourceAddedStageDelay = sourceClickDelay + SOURCE_CLICK_DURATION
    if (stage === Stage.ADD_SOURCE) {
      timeoutId = setTimeout(() => {
        setStage(Stage.SOURCES_ADDED)
      }, goToSourceAddedStageDelay * 1000)
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [stage, setStage, sourceClickDelay])

  const isVisible = stage === Stage.ADD_SOURCE

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: isVisible ? 1 : 0, scale: isVisible ? 1 : 0 }}
      transition={{
        duration: CONTEXT_MENU_VISIBLE_ANIMATION_DURATION,
        delay: contextMenuVisibleDelay,
        scale: { delay: contextMenuVisibleDelay, type: 'spring', stiffness: 300, damping: 25 },
      }}
      className={style.contextMenu}
      style={
        {
          backgroundImage: `url(${withPublicImageUrl('superhuman-go-intro-go-context-menu.svg')})`,
          '--source-click-delay': `${sourceClickDelay}s`,
          '--source-click-duration': `${SOURCE_CLICK_DURATION}s`,
        } as React.CSSProperties
      }
    >
      <div
        className={clsx(style.jiraSource, isVisible && style.clicked)}
        style={{
          backgroundImage: `url(${withPublicImageUrl('superhuman-go-intro-go-source-jira.svg')})`,
        }}
      />
    </motion.div>
  )
}
